
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./hooks/useCart";
import { AuthProvider } from "./hooks/useAuth";
import { CurrencyProvider } from "./hooks/useCurrency";
import { LanguageProvider } from "./hooks/useLanguage";
import ContactCloud from "./components/feature/ContactCloud";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <LanguageProvider>
          <CurrencyProvider>
            <CartProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppRoutes />
                <ContactCloud />
              </BrowserRouter>
            </CartProvider>
          </CurrencyProvider>
        </LanguageProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
